import { RAFFLE_EVENTS_BTN, RAFFLE_DATA_SOURCE } from '@/packages/components/hook/useRaffle'

/**
 * 组件信息
 */
export const info = {
  name: 'xy-raffle-btn', // 组件名
  type: 'component-business', // 组件类型
  label: '翻牌按钮', // 组件label
  icon: 'icon-xy-clip-raffle', // 组件图标
  defaultWidth: 0, // 组件默认宽度
  defaultHeight: 0 // 组件默认宽度
}

/**
 * 组件默认参数
 */
export const defaultProps = {
  noView: { type: Boolean, default: true }, // 是否不可见
  cardText: { type: String, default: '翻' }, // 卡牌背面文字
  cardTextColor: { type: String, default: '#fff' }, // 卡牌背面文字颜色
  cardBorderRadius: { type: Number, default: 20 }, // 卡牌圆角
  activityId: { type: String, default: '' }, // 活动id
  prizes: { type: Array, default: [] }, // 奖品列表
  prizeImages: { type: Object, default: {} }, // 奖品图片
  customDialogUUID: { type: String, default: '' }, // 抽中大奖后展示的自定义弹窗节点（为空则弹默认确认框）
  isBigRewardUnSorted: { type: Boolean, default: false }, // 大奖项可抽次数不排序
  isNewVersion: { type: Boolean, default: false }, // 是否是新版本
  isHideChangeBigRewardConfirmPopup: { type: Boolean, default: false }, // 是否隐藏切换大奖确认弹窗
  isAutoSelectBigReward: { type: Boolean, default: false }, // 是否自动选择大奖
  resetRewardData: { type: Boolean, default: true } // 是否重置翻牌记录
}

/**
 * 组件开放方法事件
 */
export const events = RAFFLE_EVENTS_BTN

/**
 * 组件开放数据源
 */
export const dataSource = RAFFLE_DATA_SOURCE

/**
 * 组件属性编辑表单信息
 */
export const editer = [
  {
    type: 'xy-form-raffle-btn' // 表单组件
  },
  {
    type: 'xy-form-input',
    label: '卡牌背文字',
    propKey: 'cardText',
    isLanguage: true
  },
  {
    type: 'xy-form-switch',
    label: '大奖项可抽次数不排序',
    propKey: 'isBigRewardUnSorted'
  }
]
